import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Icon } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ModalHeaderRight');

function ModalHeaderRight({ index, onDelete, ...props }) {
    const classes = useStyles();

    const handleDelete = useCallback(() => {
        onDelete(index);
    }, [index, onDelete]);

    return (
        <div className={classes.root}>
            <Icon name="trash" onClick={handleDelete} className={classes.icon} />
            <Icon name="verticalDivider" />
        </div>
    );
}

ModalHeaderRight.propTypes = {
    index: PropTypes.number,
    onDelete: PropTypes.func,
};

export default memo(ModalHeaderRight);
